<template>
  <div>
    <div class="d-flex justify-center">
      <table-pagination-controls
        :total-rows="missedStops.length"
        :current-page.sync="currentPage"
        :rows-per-page.sync="rowsPerPage"
        :per-page-options="pageOptions"
      />
    </div>
    <v-data-table
      dense
      hide-default-footer
      class="vf-table mt-2 mb-6"
      :items="missedStops"
      :headers="tableFields"
      :page="currentPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :items-per-page="rowsPerPage">
      <template v-slot:item.location="row">
        <router-link v-if="row.item.unregistered" :to="`/location/create?unregistered=1&code=${row.item.unregistered_code}`">
          {{ row.item.unregistered_code }} ({{ $tc('unregistered') }})
        </router-link>
        <router-link v-else :to="`/location/${row.value.id}`">
          {{ row.item.location_label }}
        </router-link>
      </template>
      <template v-slot:item.missed_stop_count="row">
        <router-link :to="formatMissedStopCountLink(row.item)">
          {{row.value}}
        </router-link>
      </template>
      <template v-slot:item.most_recent="row">
        <multi-time-display :time="row.value" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import TablePaginationControls from '@/components/shared/TablePaginationControls'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import ReportRecord from '@/orm/models/ReportRecord'
import { get, map } from 'lodash'

export default {
  name: 'MissedStopsReport',
  components: {
    TablePaginationControls,
    MultiTimeDisplay
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    report: {
      type: ReportRecord
    }
  },
  data () {
    return {
      currentPage: 1,
      rowsPerPage: 20,
      sortBy: null,
      sortDesc: false,
      pageOptions: [10, 20, 50, 100, { value: -1, text: this.$t('all') }],
      tableFields: [
        {
          value: 'location',
          text: this.$tc('location'),
          sortable: false
        },
        {
          value: 'missed_stop_count',
          text: this.$t('missed_stop_count'),
          sortable: true
        },
        {
          value: 'most_recent',
          text: this.$t('most_recent'),
          sortable: true
        }
      ]
    }
  },
  computed: {
    /**
     * @return array
     */
    missedStops () {
      return Object.values(get(this, 'report.results') || {})
    }
  },
  methods: {
    /**
     * Format missed stop link. Link to the routes index page, filtering by the ids of the routes that had missing stops
     * for the location.
     * @param stop
     * @returns {string}
     */
    formatMissedStopCountLink (stop) {
      const routeIds = map(stop.routes, item => item.id)
      return '/route/list?route_id=' + routeIds.join(',')
    }
  }
}
</script>

<style scoped>

</style>
